import _ from 'lodash';

export default {
  init() {
    $('.select-2-js').select2({
      width: '100',
    });
  },

  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
    $(window).on('scroll', _.throttle(() => {
      // This value is to make make sure the class is added precisely in the correct moment.
      const OVERDUE_OFFSET = 12;

      let menu = document.querySelector('body > header div.menu-wrapper');

      if (window.scrollY > (menu.offsetHeight - OVERDUE_OFFSET)) {
        $(menu).addClass('affix');
        $('.driving-record-cta.sticky').show();
      }

      if (window.scrollY <= (menu.offsetHeight - OVERDUE_OFFSET)) {
        $(menu).removeClass('affix');
        $('.driving-record-cta.sticky').hide();
      }
    }, 100));
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js